import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

const Footer = () => {
    const { t } = useLanguage();
    return (
        <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="flex items-center space-x-2 mb-4 md:mb-0">
                        <img src="/Logo-NP.jpeg" alt="NOPA Engineering" className="h-12 w-auto rounded-md" />
                        <span className="text-xl font-bold text-white tracking-wider">NOPA ENGINEERING</span>
                    </div>

                    <div className="flex gap-8 text-sm">
                        <a href="#about" className="hover:text-gold-500 transition-colors">{t.nav.about}</a>
                        <a href="#services" className="hover:text-gold-500 transition-colors">{t.nav.services}</a>
                        <a href="#projects" className="hover:text-gold-500 transition-colors">{t.nav.projects}</a>
                        <a href="#contact" className="hover:text-gold-500 transition-colors">{t.nav.contact}</a>
                    </div>
                </div>

                <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm">
                    <p className="mt-2 text-slate-500">PIB: 115056646 | MB: 68058970</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
